module.exports = __webpack_public_path__ + "img/the-passage.fa5d82da.webp";